import Vue from 'vue';
import Listing from './containers/Listing/index.vue';
import VModal from 'vue-js-modal';

const root = document.querySelector('#vue-listing');

Vue.use(VModal, { componentName: 'VModal' });

if (root) {
    new Vue({
        el: root,
        components: { VModal },
        render: (h) => {
            const data = root.dataset;
            return h(Listing, {
                props: {
                    endpoint: data.endpoint,
                    facets: data.facets ? data.facets.split(' ') : [],
                    selectFields: data.selectFields ? data.selectFields.split(' ') : [],
                    tabsField: data.tabsField,
                    tabsDefault: data.tabsDefault,
                    sortDefault: data.sortDefault
                }
            });
        }
    });
}
